import type { SVGProps } from "react";

export const Plus = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		fill="none"
		viewBox="0 0 32 32"
		{...props}
	>
		<path
			stroke="#0E0E0E"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M16 9v14m7-7H9"
		/>
	</svg>
);
